import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { delay, tap } from 'rxjs';
import { ROUTES } from '~console/app/~shared/constants/routes.constants';
import { ToastService } from '~console/app/~shared/services/toast.service';
import { BaseAuthComponent } from '../../abstract-components/base-auth.component';

@Component({
  selector: 'company-identification-form',
  standalone: false,
  templateUrl: './company-identification-form.component.html',
  styleUrl: './company-identification-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanyIdentificationFormComponent extends BaseAuthComponent {
  routes = ROUTES;
  private _toastService = inject(ToastService);

  isIdentifyingCompany$ = this._authFacade.isIdentifyingCompany$;
  violations$ = this._globalFacade.formViolations$.pipe(
    delay(500),
    tap({
      next: violations => {
        violations?.forEach(violation => {
          if (violation.title) {
            this._toastService.open({
              content: violation.title,
              type: 'error',
              config: {
                duration: 5000
              }
            });
          }
          this.form.get(violation.propertyPath)?.setErrors({
            httpError: violation.title
          });
        });
      }
    })
  );

  identifyCompany(): void {
    if (this.form.invalid) {
      return;
    }
    this._authFacade.identifyUserCompany(this.form.value);
  }

  form = new FormGroup({
    ncc: new FormControl('', {
      validators: [Validators.required],
      nonNullable: true
    }),
    ntd: new FormControl('', {
      validators: [Validators.required],
      nonNullable: true
    })
  });

  get ncc(): AbstractControl<string | null> | null {
    return this.form.get('ncc');
  }

  get ntd(): AbstractControl<string | null> | null {
    return this.form.get('ntd');
  }
}
